
interface SvgCloseProps {
  className?: string;
}

const SvgClose: React.FC<SvgCloseProps> = ({ className }) => {
  return (
    <svg
      className={`h-5 w-5 dark:text-red-700 ${className} z-50`}
      viewBox=" -1 -1 26 26"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="9" x2="15" y2="15" />
      <line x1="15" y1="9" x2="9" y2="15" />
    </svg>
  );
};

export default SvgClose;
